import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getEtazhiBlackFridayShowByRegion } from 'shared/actions/etazhiBlackFriday';

import type { TThunkDispatch } from 'shared/types/redux';

export function useIsEnabledByRegion() {
  const [isEnabledByRegionFetched, setIsEnabledByRegionFetched] = useState(false);

  const dispatch = useDispatch<TThunkDispatch>();

  useEffect(() => {
    dispatch(getEtazhiBlackFridayShowByRegion()).then(() => {
      setIsEnabledByRegionFetched(true);
    });
  }, [dispatch]);

  return { isEnabledByRegionFetched };
}
